<template>
  <div style="overflow:auto">
    <a-card :bordered="false" style>
      <div class="total-data">
        <div class="total-data-item">
          <div class="p1">昨日新增学员</div>
          <div class="p2">{{registMemberCount}}</div>
        </div>
        <div class="total-data-item">
          <div class="p1">总学员</div>
          <div class="p2">{{memberTotal}}</div>
        </div>
      </div>
    </a-card>
    <a-card :bordered="false" style="border-top:1px solid #E7ECEF">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          
          <a-row :gutter="12" style="margin:16px 25px;">
            <!-- <a-col class="a-large-form" >
              <a-form-item label="" style="margin-bottom:0px;width:100%">
                <a-input placeholder="请输入校区名称" v-model="queryParam.departName"></a-input>
              </a-form-item>
            </a-col> -->
            <a-col class="a-large-form">
              <a-form-item label style="margin-bottom:0px;width:100%">
                <a-input placeholder="请输入学员名称" v-model="queryParam.realname"></a-input>
              </a-form-item>
            </a-col>
            <!-- <a-col class="a-large-form">
              <a-form-item style="margin-bottom:0px" label :required="false">
                <j-dict-select-tag  v-model="queryParam.source" placeholder="学生来源" 
                 dictCode="studentSource"/>
              </a-form-item>
            </a-col> -->
            <a-col class="a-large-form">
              <a-form-item style="margin-bottom:0px" label :required="false">
                <a-input placeholder="手机号" v-model="queryParam.phone"></a-input>
              </a-form-item>
            </a-col>
            <a-col class="a-large-form">
              <a-form-item style="margin-bottom:0px" label :required="false">
                <j-dict-select-tag  v-model="queryParam.targetMajor" placeholder="报考专业" 
                 dictCode="major"/>
              </a-form-item>
            </a-col>
            <a-col class="a-large-dbdate">
              <a-form-item label style="margin-bottom:0px;width:100%">
                <a-range-picker 
                format="YYYY-MM-DD"
                style="width:100%"
                @change="onDateChange"
                @ok="onDateOk" />
              </a-form-item>
            </a-col>
            <a-button
              type="primary"
              @click="searchQuery"
              style="margin-left:5px;margin-right:10px;vertical-align: middle;"
            >筛选</a-button>
            <a-button @click="gameCreate()" v-has="'userInfo:add'" type="primary" icon="plus" style="float:right;" >新增学员</a-button>
            <a-button
              type="primary"
              icon="download"
              style="margin-right:10px;vertical-align: middle;"
              @click="handleExportXls('学员信息')"
            >>导出学员</a-button>
            <!-- <a-upload
            name="file"
            :showUploadList="false"
            :multiple="false"
            :headers="tokenHeader"
            :action="importExcelUrl"
            @change="handleImportExcel"
          > -->
            <!-- <a-button type="primary" style="vertical-align: middle;"  icon="import">导入学员</a-button> -->
            <!-- </a-upload> -->
          </a-row>
          <a-row :gutter="24" style="margin:16px 25px;">
            <a-col :span="5"></a-col>
          </a-row>
        </a-form>
      </div>
      <div>
        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :scroll={x:1800}
        >
          <div slot="englishName" slot-scope="text, record">
            <div class="userInfo-img" >
              <img :src="record.avatar" alt width="80" />
            </div>
            <!-- <div class="userInfo-right">
              <div class="userInfo-name">
                <a @click="userEdit(record)">{{record.englishName}}</a>
              </div>
            </div> -->
          </div>
          <div slot="classTime" slot-scope="text, record">
            <div class="class-time-up">
              {{record.classTime1}}
            </div>
            <div class="class-time-down" v-if="record.classTime2 !=null">
              {{record.classTime2}}
            </div>
          </div>

          <span slot="action" slot-scope="text, record">
            <a @click="userEdit(record)">编辑</a>
            <!-- <a-divider type="vertical" /> -->
            <!-- <a @click="handlePerssion(record.id,record.sysOrgCode)">课程权限</a>
            <a-divider type="vertical" /> -->
            <!-- <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm> -->
          </span>
        </a-table>
       <div class="fixed-tab-con">
          <div class="fixed-tab"> 
             <!-- <a-button
              type="primary"
              style="margin-right:10px;height:41px;width:232px;text-align:center;"
            @click="sendClassNotifyToUser()">发送消息</a-button> -->
            <a-button
              style="height:41px;width:135px;text-align:center;"
              @click="addToBlackList()"
            >加黑名单</a-button>
          </div>
        </div> 
      </div>
    </a-card>
    <student-role-modal ref="modalUserRole"></student-role-modal>
  </div>
</template>

<script>
import StudentRoleModal from '@/components/studentManagement/studentList/StudentRoleModal'
import { getUserIndex,addBlackList  } from "@/api/api";
import { JeecgListMixin } from "@/mixins/JeecgListMixin";
export default {
  name: "StudentManage",
  mixins: [JeecgListMixin],
  components: {
    StudentRoleModal
  },
  data() {
    return {
      memberTotal:"",
      registMemberCount:"",
      selectedData: [],
      selectedIds: [],
      queryParam: {
        realname: "",
        phone: "",
        userType: "",
        school: "",
        classname: "",
        startDate: "",
        endDate: "",
        registTime:[]
      },
      // 表头
      description: "学员管理页面",
      columns: [
        {
          title: "头像",
          align: "center",
          scopedSlots: { customRender: "englishName" }
        },
        {
          title: "昵称",
          align: "center",
          dataIndex: "realname"
        },
        {
          title: "性别",
          align: "center",
          dataIndex: "sex_dictText",
         
        },
        {
          title: "生日",
          align: "center",
          dataIndex: "birthday"
        },
        // {
        //   title: "来源",
        //   align: "center",
        //   dataIndex: "",
        //   scopedSlots:  (text, row, index) => {
              
        //     return (<span >线上</span>)
            
        //   } 
        // },
        {
          title: "手机号",
          align: "center",
          dataIndex: "phone"
        },
        {
          title: "所属校区",
          align: "center",
          dataIndex: "source",
          customRender: (text, row, index) => {
              
            return (<span >网络校区</span>)
            
          }
        },
         {
          title: "学历",
          align: "center",
          dataIndex: "education_dictText" 
        },
        {
          title: "报考院校",
          align: "center",
          dataIndex: "targetSchool" 
        },
        {
          title: "报考专业",
          align: "center",
          dataIndex: "targetMajor" 
        },
       
        {
            title: '注册时间',
            align: 'center',
            dataIndex: 'createTime'
        },
        {
            title: '最后登录时间',
            align: 'center',
            dataIndex: 'loginSuccess'
        },
         {
          title: "积分",
          align: "center",
          dataIndex: "coin"
        },
         {
          title: "消费金额",
          align: "center",
          dataIndex: "totalCost"
        },
        {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
            width:260,
            // fixed:"right"
          }
      ],
      dataSource: [],
      url: {
        list: "/userInfo/student/list",
        delete:"userInfo/student/delete",
        // addBlackList: '/userInfo/addBlackList',
        // removeBlackList: '/userInfo/removeBlackList',
        // // deleteBatch: '/course/elinkxCourse/deleteBatch',
        exportXlsUrl: "/userInfo/student/exportXls",
        // importExcelUrl: "userInfo/importExcel"
        // blackList: '/userInfo/blacklist'
      }
    };
  },
  created() {
    this.initUserInfo();
  },
  methods: {
    userEdit(record){
      this.$router.push({ path:'/studentManagement/StudentEdit?id='+record.id});
    },
    gameCreate(){
      this.$router.push({ path:'/studentManagement/StudentEdit'});
    },
    refreshData:function(){
      this.searchQuery();
    },
    initUserInfo: function() {
      getUserIndex().then(res => {
          if (res.success) {
            this.registMemberCount = res.result.registMemberCount;
            this.memberTotal = res.result.memberTotal;
          } else {
            this.$message.warning(res.message);
          }
        })
        .finally(() => {});
    },
    addToBlackList() {
      if (this.selectedIds.length != 0) {
        const param = {
          "idList":this.selectedIds
        }
        addBlackList(param).then(res=>{
          if(res.success){
            this.$message.success("成功加入黑名单");
            this.searchQuery();
          }else{
            this.$message.success("操作失败！");
          }
          
        });
       
      } else {
        this.$message.warning("请选择至少一条数据");
      }
    },
    sendClassNotifyToUser() {
      if (this.selectedIds.length != 0) {
        const param = {
          "ids":this.selectedIds
        }
        sendClassNotifyToUser(param).then(res=>{
          if(res.success){
            this.$message.success(res.message);
           // this.searchQuery();
          }else{
            this.$message.success("消息发送失败！");
          }
          
        });
       
      } else {
        this.$message.warning("请选择至少一条数据");
      }
    },
    onDateChange: function (value, dateString) {
        this.queryParam.createTime_begin =dateString[0];
        this.queryParam.createTime_end=dateString[1];
      },
    onDateOk(value) {
    },
    handlePerssion: function(roleId,sysOrgCode){
      this.$refs.modalUserRole.show(roleId,sysOrgCode);
    },
  },

  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG["domianURL"]}/${this.url.importExcelUrl}`;
    },
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedData = [];
           this.selectedIds = [];
          selectedRows.forEach(row => {
            this.selectedData.push(row.phone);
            this.selectedIds.push(row.id);
          });
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name
          }
        })
      };
    }
  }
};
</script>

<style scoped>
@import "~@assets/less/common.less";
</style>

<style lang="scss" scoped >
.total-data {
  .total-data-item {
    float: left;
    width: 50%;
    margin: 10px 0px;
    &:first-child {
      border-right: 1px solid #e7ecef;
    }
    .p1 {
      text-align: center;
      font-size: 14px;
      color: #333333;
    }
    .p2 {
      text-align: center;
      color: #fa6400;
      font-size: 40px;
    }
  }
}
.fixed-tab-con {
  // display: none;
  height: 70px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
  position: fixed;
  bottom: 0px;
  left: 0px;
  text-align: center;
  width: 100%;
  // padding-left: 220px;
  .fixed-tab {
    margin-top: 16px;
  }
}
.userInfo-img {
  // float: left;
  //text-align: center;
  margin: 0 auto;
  width: 54px;
  height: 54px;
  margin-bottom: 20px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #eee;
  
  img {
    height: 100%;
    width: 100%;
  }
}
.userInfo-right {
  padding-left: 10px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 80px;
  .userInfo-name {
    font-size: 14px;
    color: #0091ff;
    padding: 10px 0px;
  }
}
.class-time-up{
  text-align: left;
  padding-left: 10px;
}
.class-time-down{
  text-align: left;
  padding-top: 30px;
}

</style>